export default {"src":"/_next/static/media/sodexo.8df94591.svg","height":24,"width":72,"blurWidth":0,"blurHeight":0};